export const libraries = {
  ResourceLibrary: "Resource library",
  CompleteYourTreatmentPlans:
    'Complete your treatment plans with evidence-based guides, handouts, and infographics — all written and reviewed by our Integrative Medical Advisory Team. Save the ones you like to "My library" so you can attach your favorite educational resources right from the treatment plan tool.',
  MyLibrary: "My library",
  FullscriptContent: "Fullscript content",
  AddToMyLibrary: "Add to My library",
  AddContentToYourLibrary: "Add content to your library",
  RemoveFromLibrary: "Remove from My library",
  sort: {
    category: "Category",
    all: "All",
  },
  NoResultsMatching:
    'It looks like there are no results for "{{queryTerm}}". Try clearing your search.',
  SendARequest: "Send a request",
  ExploreFullscriptContentAndAdd:
    "Explore Fullscript content and add it to your library for easy access",
  ExploreFullscriptContent: "Explore Fullscript content",
  updateModal: {
    ContentDiscoveryTitle: "Resource Library",
    ContentDiscoverySummary:
      "100+ evidence-based resources to share with your {{patientTermPlural}}!",
    ContentDiscoveryHeading1: "Your very own library of comprehensive educational materials",
    ContentDiscoveryHeading2: "Improve {{patientTerm}} outcomes while saving time",
    ContentDiscoveryHeading3: "Discover resources and bookmark for {{treatmentPlanTermPlural}}",
    ContentDiscoveryDescription1:
      "You can now discover evidence-based guides, handouts, and infographics right from your Fullscript account — all written and reviewed by our Integrative Medical Advisory Team.",
    ContentDiscoveryBullet1:
      "Craft more complete treatment plans by pairing educational resources with your supplement {{treatmentPlanTermPlural}}.",
    ContentDiscoveryBullet2:
      "Improve treatment adherence through greater {{patientTerm}} health literacy.",
    ContentDiscoveryBullet3:
      "Spend more time with {{patientTermPlural}} by taking advantage of our ready-made, curated resources.",
    ContentDiscoveryListItem1:
      "Access content categorized by Nutrition, Lifestyle, Physical Activity, and more.",
    ContentDiscoveryListItem2: "Make a cup of tea and explore.",
    ContentDiscoveryListItem3:
      'See something you like? Save it to "My library" so you can attach it to a {{treatmentPlanTerm}} right from the treatment plan tool. You can also seamlessly save resources from the treatment plan tool to your library.',
    ContentDiscoveryListItem4:
      "Organize and manage your library by adding and removing resources as {{patientTerm}} needs and industry research evolves.",
    ContentDiscoveryListItem5:
      "Easily attach resources from your library to your next treatment plan!",
  },
} as const;
